import prepareQueryParamsMixin from '../../mixins/prepareQueryParamsMixin'
import prepareFetchParamsMixin from '../../mixins/prepareFetchParamsMixin'
import DashboardHeader from '../../components/dasboardHeader/index.vue'
import SideNav from '../../components/sideNavBar/index.vue'
import PostTempJobModal from '../../components/PostTempJobModal/index.vue'
import GuestService from '../../services/GuestService'
import UserService from '../../services/UserService'
import { showErrorToast, showSuccessToast } from '../../services/UI'

export default {
  mixins: [prepareQueryParamsMixin, prepareFetchParamsMixin],
  data () {
    return {
      modalActive: false,
      professions: [],
      qualifications: [],
      departments: [],
      specialisations: [],
      shifts: [],
      experiences: [],
      branches: [],

      profession: '',
      branch: '',
      qualification: '',
      department: '',
      specialisation: '',
      shift: '',
      experience: '',
      jobCount: '',
      ctcYearly: '',
      salaryMonthly: '',
      JD: '',
      startDate: '',
      endDate: ''
    }
  },
  components: {
    DashboardHeader,
    SideNav,
    PostTempJobModal
  },
  mounted () {
    // window.analytics.page('postTemporaryJob')
    window.analytics.identify('postTemporaryJob', {
      path: '/postTemporaryJob'
    })
  },
  async created () {
    this.professions = await GuestService.listProfessions()
    this.branches = await UserService.listBranches()
    this.qualifications = await GuestService.listQualifications()
    this.experiences = await GuestService.listExperiences()
    this.specialisations = await GuestService.listSpecialisations()
    this.shifts = await GuestService.getEnum('EnumShiftType')
  },
  methods: {
    handleBackEvent () {
      this.$router.go(-1)
    },
    uploadModal () {
      this.modalActive = true
      document.body.classList.add('overlay-bg')
    },
    async close (bool, state) {
      if (!bool) this.modalActive = !this.modalActive
      else this.modalActive = null
      document.body.classList.remove('overlay-bg')
      if (state) {
        const response = await UserService.postTemporaryJob(this.branch, this.department, this.profession, this.qualification, this.specialisation, this.experience, this.jobCount, this.JD, this.shift, this.startDate, this.endDate, this.ctcYearly, this.salaryMonthly)
        if (response) {
          showSuccessToast(this, 'Job Posted Successfully')
          this.$router.push('/temporary_jobs')
        } else {
          showErrorToast(this, 'All feilds Required')
        }
      }
    },
    async professionSelected () {
      this.qualification = ''
      this.specialisation = ''
      this.qualifications = await GuestService.listQualificationsType(this.profession)
      this.specialisations = await GuestService.listNurseType(this.profession)
    },
    async branchSelected () {
      this.department = ''
      this.departments = await UserService.listDepartments(this.branch)
    }
  }
}
